export const CONTACT = {
  commercialEmail: 'commercial@rangesafe.com',
  generalEmail: 'info@rangesafe.com',
  phone: '(434) 229-7401',
  phoneHref: 'tel:+14342297401',
};

export const RETAIL_URL = 'https://www.rangesafe.com/';

export const NAV_LINKS = [
  { label: 'Company', href: '/about' },
  { label: 'Products', href: '/products' },
  { label: 'Industries', href: '/industries' },
  { label: 'Manufacturers', href: '/manufacturers' },
  { label: 'Resources', href: '/resources' },
];

export const BUYER_CATEGORIES = [
  'Property owner or manager',
  'Government or institutional buyer',
  'Hospitality operator',
  'Educational institution',
  'Senior or specialty housing operator',
  'Appliance manufacturer / OEM team',
  'Insurance',
  'Other',
];

export const NEED_OPTIONS = [
  { value: 'quote', label: 'Request a Consultation' },
  { value: 'pilot', label: 'Evaluate a pilot program' },
  { value: 'compatibility', label: 'Compatibility review' },
  { value: 'oem', label: 'OEM / manufacturing discussion' },
  { value: 'documentation', label: 'Documentation for internal review' },
  { value: 'other', label: 'Something else' },
];

export const TIMELINE_OPTIONS = [
  'Evaluating now',
  'This quarter',
  'Next 6 months',
  'Next 12 months',
  'No fixed timeline',
];

export const PROPERTY_RANGES = ['1', '2–5', '6–20', '21–100', '100+'];
export const APPLIANCE_RANGES = ['1–10', '11–50', '51–250', '251–1,000', '1,000+'];
